var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42.005,
    viewBox: "0 0 42 42.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Caminho_169",
    d: "M152.168 118.652l-5.591-5.586a3.612 3.612 0 0 0-5.124 0l-6.022 6.011a3.625 3.625 0 0 0 0 5.135l4.7 4.709a21.568 21.568 0 0 1-11.214 11.23l-4.7-4.709a3.612 3.612 0 0 0-5.124 0l-6.027 6.011a3.625 3.625 0 0 0 0 5.135l5.586 5.586a6.286 6.286 0 0 0 4.421 1.832 5.892 5.892 0 0 0 1.008-.084 38.117 38.117 0 0 0 29.836-29.841 6.258 6.258 0 0 0-1.748-5.429zm-1.974 4.8a34.4 34.4 0 0 1-26.738 26.748 2.469 2.469 0 0 1-2.142-.693l-5.486-5.486 5.817-5.822 6.29 6.3.047.047 1.134-.42a25.268 25.268 0 0 0 15-15l.42-1.134-6.342-6.337 5.817-5.822 5.486 5.486a2.458 2.458 0 0 1 .7 2.142z",
    "data-name": "Caminho 169",
    transform: "translate(-112 -112)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.56d51a5b.svg";
export { ForwardRef as ReactComponent };